
import React from 'react';
import { Calendar } from 'primereact/calendar';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import CalendarHeader from '../CalendarHeader/CalendarHeader';
import CalendarFooter from '../CalendarFooter/CalendarFooter';
import { useSelector } from 'react-redux';
import { isToday } from 'src/utils/dateUtils';
import useWeekViewDomEffects from '../hooks/useWeekViewDomEffects';

const WeekView = ({ addSurgeryDates, changeSelectedDate }) => {
    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );
    const visibleDateRange = useSelector(
        (state) => state.filterReducer.visibleDateRange
    );
    useWeekViewDomEffects(visibleDateRange, selectedDate, addSurgeryDates);
    return (
        <Calendar
            value={selectedDate}
            onChange={(e) => {
                changeSelectedDate(e.value);
            }}
            viewDate={selectedDate}
            onViewDateChange={(e) => {
                changeSelectedDate(e.value);
            }}
            minDate={new Date(visibleDateRange[0])}
            maxDate={new Date(visibleDateRange[1])}
            headerTemplate={() => (
                <CalendarHeader
                    showTodayButton={!isToday(selectedDate)}
                    changeSelectedDate={changeSelectedDate}
                />
            )}
            footerTemplate={() => <CalendarFooter />}
            selectOtherMonths={true}
            inline
        />
    );
};

export default WeekView;
